import {
  ADD_USER_REQUEST,
  ADD_USER_SUCCESS,
  ADD_USER_FAILURE,
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  TOGGLE_USER_STATUS_REQUEST,
  TOGGLE_USER_STATUS_SUCCESS,
  TOGGLE_USER_STATUS_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  CLEAR_USERS_ERROR,
} from "../actions/userActionTypes";

const initialState = {
  users: [],
  isLoading: false,
  addUserError: null,
  fetchUsersError: null,
  updateUserError: null,
  deleteUserError: null,
  toggleUserStatusError: null,
  changePasswordError: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_USER_REQUEST:
      return {
        ...state,
        isLoading: true,
        addUserError: null,
      };

    case ADD_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        users: [...state.users, action.payload],
        addUserError: null,
      };

    case ADD_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        addUserError: action.payload,
      };

    case FETCH_USERS_REQUEST:
      return {
        ...state,
        isLoading: true,
        fetchUsersError: null,
      };

    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        users: action.payload,
        fetchUsersError: null,
      };

    case FETCH_USERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        fetchUsersError: action.payload,
      };

    case UPDATE_USER_REQUEST:
      return {
        ...state,
        isLoading: true,
        updateUserError: null,
      };

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.map((user) =>
          user.id === action.payload.id ? action.payload : user,
        ),
        isLoading: false,
        updateUserError: null,
      };

    case UPDATE_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        updateUserError: action.payload,
      };

    case DELETE_USER_REQUEST:
      return {
        ...state,
        isLoading: true,
        deleteUserError: null,
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.filter((user) => user.id !== action.payload),
        isLoading: false,
        deleteUserError: null,
      };

    case DELETE_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        deleteUserError: action.payload,
      };

    case TOGGLE_USER_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true,
        toggleUserStatusError: null,
      };

    case TOGGLE_USER_STATUS_SUCCESS:
      return {
        ...state,
        users: state.users.map((user) =>
          user.id === action.payload.id
            ? { ...user, isActive: action.payload.isActive }
            : user,
        ),
        isLoading: false,
        toggleUserStatusError: null,
      };

    case TOGGLE_USER_STATUS_FAILURE:
      return {
        ...state,
        isLoading: false,
        toggleUserStatusError: action.payload,
      };

    case CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        isLoading: true,
        changePasswordError: null,
      };

    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        changePasswordError: null,
      };

    case CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        isLoading: false,
        changePasswordError: action.payload,
      };

    case CLEAR_USERS_ERROR:
      return {
        ...state,
        addUserError: null,
        fetchUsersError: null,
        updateUserError: null,
        deleteUserError: null,
        toggleUserStatusError: null,
        changePasswordError: null,
      };

    default:
      return state;
  }
};

export default userReducer;
